import React from 'react';
import PropTypes from 'prop-types';
import { times } from 'lodash';
import {
  FormControlLabel,
  IconButton,
  Switch,
  TableCell,
  TableRow,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import styled from 'styled-components';
import { em, lighten } from 'polished';
import { mediaQuery } from '../../common';
import { appTheme } from '../../../theme';
import { COLUMNS } from '../constants';

const getColumnHeadings = (value, index) =>
  `&:nth-child(${index + 1})::before {
    content: '${!!value ? `${value}: ` : ''}';
    font-weight: bold;
    margin-right: ${!!value ? em(10) : 0};
  }`;

const Row = styled(TableRow)`
  height: 48px;

  &:nth-child(even) {
    background-color: ${lighten(0.07, appTheme.system.border)};
  }
`;

const Cell = styled(TableCell)`
  ${COLUMNS.map(getColumnHeadings)};

  ${mediaQuery.xlarge`
    display: table-cell;
    padding: 4px 56px 4px 24px; /* pixel values to match material-ui */

    ${times(COLUMNS.length, index => getColumnHeadings('', index))}
  `};

  /* stylelint-disable-next-line order/properties-alphabetical-order */
  align-items: center;
  display: flex;
  padding: ${em(appTheme.spacing.medium)};
  vertical-align: middle;
`;

const SwitchLabel = styled(FormControlLabel)`
  ${mediaQuery.xlarge`
    font-size: ${em(13)};
    margin-left: 14px;
  `};

  /* stylelint-disable-next-line order/properties-alphabetical-order */
  margin-left: 45px;
`;

const Action = styled.div`
  display: inline-flex;
  position: absolute;
  top: 0;
`;

const ActionCell = styled(Cell)`
  height: 48px;
  position: relative;
`;

class UserDetails extends React.Component {
  static propTypes = {
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    lastName: PropTypes.string.isRequired,
    onChangeStatus: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,

    isAdmin: PropTypes.bool,
  };

  static defaultProps = {
    isAdmin: false,
  };

  handleChangeStatus = () => {
    const {
      email,
      firstName,
      lastName,
      id,
      isActive,
      onChangeStatus,
    } = this.props;

    onChangeStatus({
      email,
      firstName,
      id,
      lastName,
      isActive: !isActive,
    });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id);
  };

  render() {
    const { email, firstName, isActive, isAdmin, lastName } = this.props;

    if (isAdmin) return null;

    return (
      <Row>
        <Cell>{lastName}</Cell>
        <Cell>{firstName}</Cell>
        <Cell>{email}</Cell>
        <ActionCell>
          <Action>
            <SwitchLabel
              control={
                <Switch
                  checked={isActive}
                  color="primary"
                  onChange={this.handleChangeStatus}
                  value="isActive"
                />
              }
              label={isActive ? 'Active' : 'Inactive'}
            />
          </Action>
        </ActionCell>
        <ActionCell>
          <Action>
            <IconButton onClick={this.handleDelete}>
              <DeleteIcon />
            </IconButton>
          </Action>
        </ActionCell>
      </Row>
    );
  }
}

export default UserDetails;



// WEBPACK FOOTER //
// ./src/modules/UserManagement/components/UserDetails.js